/*
  Priority between upsell blocks.
  Every upsell block with a "Priority group" renders its container with
  data-upsell-group / data-upsell-priority and an <upsell-priority-guard> child.
  When several containers of the same group are on screen at once (e.g. two
  products in the cart, each with its own block), only the one with the highest
  priority stays visible; ties go to the block placed first. Blocks whose products
  are all hidden (already in the cart / unavailable) never win.
  Runs again on every cart drawer re-render because the guard is a custom element
  (its connectedCallback fires each time the drawer HTML is rebuilt).
*/
(function () {
  if (window.customElements.get('upsell-priority-guard')) return;

  class UpsellPriorityGuard extends HTMLElement {
    connectedCallback() {
      // Let the rest of the freshly inserted HTML land in the DOM first.
      queueMicrotask(() => UpsellPriorityGuard.resolve(this));
    }

    static resolve(guard) {
      const container = guard.parentElement;
      if (!container || !container.dataset.upsellGroup) return;
      const group = container.dataset.upsellGroup;
      const scope = container.closest('cart-drawer') || container.closest('.shopify-section') || document;
      const containers = Array.from(scope.querySelectorAll('[data-upsell-group]')).filter(
        (c) => c.isConnected && c.dataset.upsellGroup === group
      );
      if (!containers.length) return;

      const eligible = containers.filter((c) => c.querySelector('.upsell'));
      let winner = null;
      eligible.forEach((c) => {
        const p = Number(c.dataset.upsellPriority || 0);
        if (!winner || p > Number(winner.dataset.upsellPriority || 0)) winner = c;
      });

      containers.forEach((c) => {
        if (c === winner) {
          c.style.removeProperty('display');
          c.removeAttribute('data-upsell-hidden');
        } else {
          c.style.display = 'none';
          c.setAttribute('data-upsell-hidden', 'true');
        }
      });
    }
  }

  window.customElements.define('upsell-priority-guard', UpsellPriorityGuard);
})();
